// src/publish/pieces/linkedinNewsletter.js — pieces of the LinkedIn newsletter (format key 'linkedin-newsletter').
//
// The Writer answers with title, subtitle, hook, sections[] (h2 / content /
// subsections[] h3 / content), key_takeaways[], closing_paragraph and
// companion_post (no references[]). Pieces, in this
// order (ids pinned by the sample's tobe/pezzi.json), each only when its field
// is non-empty:
//   article     primary, 'rich' — h1 title, subtitle paragraph, hook
//               paragraphs, h2 sections with content and h3 subsections, an h2
//               «Punti chiave» (the takeaways label) + a numbered list, then
//               the closing paragraph(s)
//   title       the title alone          subtitle   the subtitle alone
//   takeaways   kind 'list' — the numbered key takeaways
//   companion   the feed post that announces the newsletter (never part of
//               the article)
// No 'sources' piece: the newsletter text carries no "[N]" markers and the
// proposal's piece table (and the sample's tobe/pezzi.json) ends at the
// companion post; content.references is not read here.
// The long fields may carry inline HTML: every one goes through normalize.js
// once. Nothing here reads full_text.

import { heading, paragraph, list } from '../blocks.js';
import { normalizeText, inlineRuns } from '../normalize.js';
import { makePiece, pieceLabel, ensureOnePrimary, str, arr } from '../piece.js';
import { sectionBlocks } from './blogSeo.js';

const FORMAT = 'linkedin-newsletter';

function takeawayItems(takeaways) {
  return arr(takeaways)
    .map((t) => inlineRuns(str(t).trim()))
    .filter((runs) => runs.length);
}

export function build(entry) {
  const content = entry?.results?.content;
  if (!content || typeof content !== 'object') return [];
  const pieces = [];

  const title = str(content.title).trim();
  const subtitle = str(content.subtitle).trim();
  const takeaways = takeawayItems(content.key_takeaways);

  const article = [];
  if (title) article.push(heading(1, inlineRuns(title)));
  if (subtitle) article.push(paragraph(inlineRuns(subtitle)));
  article.push(...normalizeText(str(content.hook)));
  article.push(...sectionBlocks(content.sections));
  if (takeaways.length) {
    article.push(heading(2, pieceLabel(FORMAT, 'takeaways')));
    article.push(list(takeaways, true));
  }
  article.push(...normalizeText(str(content.closing_paragraph)));
  if (article.length) pieces.push(makePiece(FORMAT, { id: 'article', kind: 'rich', blocks: article }));

  if (title) pieces.push(makePiece(FORMAT, { id: 'title', blocks: [paragraph(inlineRuns(title))] }));
  if (subtitle) pieces.push(makePiece(FORMAT, { id: 'subtitle', blocks: [paragraph(inlineRuns(subtitle))] }));
  if (takeaways.length) pieces.push(makePiece(FORMAT, { id: 'takeaways', kind: 'list', blocks: [list(takeaways, true)] }));

  const companion = normalizeText(str(content.companion_post));
  if (companion.length) pieces.push(makePiece(FORMAT, { id: 'companion', blocks: companion }));

  return ensureOnePrimary(pieces, ['article']);
}
